export default {
    confirmEmailSuccess(state, data) {
        state.loading = false;
        state.validationMessage = data;
        state.validationTitle = 'Email verification success';
    },

    confirmEmailErr(state, err) {
        state.loading = false;
        state.validationMessage = err;
        state.validationTitle = 'Email verification error';
    }
};